import en from './en/main';
import ru from './ru/main';

export default {
  en,
  ru,
};
